// extracted by mini-css-extract-plugin
export default {"servicesSection":"ServicesSection_servicesSection__Tt-Ml","serviceCardContainer":"ServicesSection_serviceCardContainer__vdhMB"};